import { createAction, props } from '@ngrx/store';

export const updateTabIndex = createAction('[Company Slide Out Component] Update Tab Index', props<{ index: number }>());

export const clearState = createAction('[Company Slide Out Component] Clear State');
